import React, {Component} from "react"
import PropTypes from "prop-types"
import {RouteComponentProps} from "react-router-dom"

import {NestedRoute} from "@irati/utils/history/routing"

import MyPerksList from "../components/MyPerks/MyPerksList"

interface Props extends RouteComponentProps<{url: string}> {}

class AccountRoute extends Component<Props> {
  static contextTypes = {
    appPath: PropTypes.string
  }

  render() {
    const {match} = this.props

    return <NestedRoute match={match.url} path="/my-perks/:redemptionStatus" title="My perks" component={MyPerksList} />
  }
}

export default AccountRoute
